import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';
import PersonCard from './PersonCard';
import ralphImg from './pictures/dark/ralph.jpeg';
import frankieImg from './pictures/dark/frankie.jpeg';
import joshImg from './pictures/dark/josh.jpeg';
import nickImg from './pictures/dark/nick.jpeg';
import jamesImg from './pictures/dark/james.jpeg';
import lewisImg from './pictures/dark/lewis.jpeg';
import sophiaImg from './pictures/dark/sophia.jpeg';
import jackImg from './pictures/dark/jack.jpeg';
import chasImg from './pictures/dark/chas.jpeg';
import tomImg from './pictures/dark/tom.png';
import freddieImg from './pictures/dark/freddie.png';
import arturImg from './pictures/dark/artur.png';
import stefanoImg from './pictures/dark/stafano.png';
import colinImg from './pictures/dark/colin.png';

import css from './SectionTeam.module.css';

const SectionTeam = () => {
    return <div className={css.root}>
        <div>
            <h2 className={css.sectionTitle}>
                <FormattedMessage id="MLP.team.title" />
            </h2>
            <p className={css.desc}>
                <FormattedMessage id="MLP.team.text" />
            </p>
            <NamedLink name="CMSPage" params={{ pageId: "team" }} className={css.whiteLink}>
                <FormattedMessage id="MLP.team.button" />
            </NamedLink>
        </div>

        <div className={css.pictures}>
            <PersonCard
                picture={joshImg}
                name="Josh Benbow"
                title="Managing Director"
                description="8 years experience in alternative and physical asset trading. 5 years as a portfolio manager at a leading firm, then 3 years as a private intermediary before creating Parnexus. Josh's early career was focused on investment in passion assets."
            />

            <PersonCard
                picture={nickImg}
                name="Nick Cox"
                title="Head of Commercial"
                description="Accomplished commercial sales leader with 10 year success driving thriving teams and business growth. Nick has operated sales teams at leading premium and Saas brands, to buyouts. Expertise in business development, strategic partnerships, and key account management."
            />

            <PersonCard
                picture={jamesImg}
                name="James Goldsztajn"
                title="Automotive Account Director"
                description="Accomplished automotive professional with 7 years of success in the luxury and collectible car market. James has led sales operations at premium dealerships and specialist brokerages, sourcing and selling rare, off-market vehicles to elite clients worldwide. James has a reputation for deep product knowledge as well as trusted private and industry relationships."
            />

            <PersonCard
                picture={tomImg}
                name="Tom McCollum"
                title="Partner"
                description="Starting in corporate finance (tech & media) at KPMG, Tom worked on M&A deals globally worth more than £10bn over 4 years. Tom is ACA qualified and has 8 years of experience in corporate finance. He runs a private property investment firm primarily focussed on residential real estate."
            />

            <PersonCard
                picture={freddieImg}
                name="Freddie Hill"
                title="Residential Real Estate Account Director"
                description="Freddie joined from Knight Frank LLP where he was a partner for 8 years. He brings a wealth of knowledge and contacts from markets in London, Europe, Asia and the Middle East. He’s an experienced UHNW relationship manager with over 15 years of expertise in investments and business development."
            />

            <PersonCard
                picture={arturImg}
                name="Artur Silva"
                title="Fine Wine and Whiskey Account Director"
                description="Artur spent over a decade in New York fine dining, as a buyer for wine and spirits at the Jean-Georges group, Gary Vaynerchuck’s VCR, and Birley’s private members club Maxime’s. Artur is an expert in collectable wines and spirits."
            />

            <PersonCard
                picture={stefanoImg}
                name="Stefano Lanca"
                title="Head of Yachts"
                description="Stefano has a decade of experience in yacht brokerage, and has worked closely with buyers and sellers across the luxury market. He is a passionate relationship builder and innately understands the importance of trust, discretion and direct communication. He's driven by integrity and long-term value."
            />

            <PersonCard
                picture={colinImg}
                name="Colin Dunne"
                title="Head of Aviation"
                description="Colin spent 10 years in aircraft sales at AerData, a Boeing subsidiary, and Jetcraft, working across Europe and the Middle East before leading Midwest sales from Chicago. He advises high-net-worth individuals, family offices and corporations on charter, fractional and full ownership."
            />

            <PersonCard
                picture={lewisImg}
                name="Lewis Boyles-White"
                title="CTO"
                description="15 years of experience as a commercially minded software developer. Specialist in high security, high assurance software. Experienced angel investor and business advisor."
            />

            <PersonCard
                picture={frankieImg}
                name="Frankie Kettnaker"
                title="Operations Manager"
                description="Frankie oversees operations and company administration. Her roles include overseeing events, travel, payroll, sales and marketing support and liaising with accountants and team diary management."
            />

            <PersonCard
                picture={sophiaImg}
                name="Sophia Pimenta"
                title="Communications Manager"
                description="With a background in marketing, AI product strategy, and GTM, she leads Parnexus’s marketing and communications strategy."
            />

            <PersonCard
                picture={jackImg}
                name="Jack Collins"
                title="Institutional Debt & Capital Introductions Special Projects"
                description="Over 25 years experience in banking, finance, private client and real estate. Experience across debt, real estate development, asset management, acquisitions and disposals."
            />

            <PersonCard
                picture={ralphImg}
                name="Ralph Hazell"
                title="Head of KYC / AML"
                description="Having founded four fintech companies, Ralph is an experienced Money laundering reporting officer (MLRO). He oversaw the implementation of anti money laundering policies and ensured activities comply with AML regulations as well as implementing customer due diligence and KYC procedures. He oversees Parnexus KYC / AML desk."
            />

            <PersonCard
                picture={chasImg}
                name="Chas Howes"
                title="Non-executive CFO"
                description="Ex FTSE 250 CFO. Angel investor and experienced business advisor and chairman."
            />
        </div>
    </div>
};

export default SectionTeam;
